/**
 * @file   : ContactUsCardFront.js
 * @author : Amarjeet Lamba (Amarjeet.Lamba@AspiraConnect.com)
 * @date   : 2/4/2019, 6:16:33 PM
 */
import PropTypes from 'prop-types'
import React from 'react'

import Cont from '../../../external/components/layout/Cont'
import TextHoverable from '../../../external/components/link/TextHoverable'
import AImg from '../../../external/components/media/img/AImg'
import { isEmpty, isUndefined } from '../../../external/utilities/GeneralUtils'
import { CHANNEL_WEB } from '../ContactUsContainer'

const ContactUsCardFront = ({ client }) => {
  const getLogoUI = function () {
    let logoUI = <Cont />
    if (!isEmpty(client.logoURL)) {
      logoUI = (
        <AImg
          className="contact-card-logo"
          imageURL={client.logoURL}
          cmpLabel={client.name}
          cmpTitle={client.name}
        />
      )
    }

    return logoUI
  }

  const getTitleUI = function () {
    let hasWeb = false
    let webIdentifier = null
    if (
      !isEmpty(client) &&
      !isUndefined(client.contactChannels) &&
      !isEmpty(client.contactChannels)
    ) {
      for (const channel of client.contactChannels) {
        if (channel.type === CHANNEL_WEB) {
          hasWeb = true
          webIdentifier = channel.identifier
        }
      }
    }

    return (
      <TextHoverable
        to={hasWeb ? webIdentifier : null}
        newWin
        internal={false}
        fontSizeType={4}
        fontFamily={'Georgia'}
      >
        {client.name}
      </TextHoverable>
    )
  }

  return (
    <Cont className="contact-card-container">
      <Cont className="contact-card-top-section">{getLogoUI()}</Cont>
      <Cont className="contact-card-bottom-section">{getTitleUI()}</Cont>
    </Cont>
  )
}

ContactUsCardFront.propTypes = { client: PropTypes.object.isRequired }

export default ContactUsCardFront
